import { IconsUnion } from '@globalmed/atlas-ui';
import {
  EFormBuilderFieldType,
  ESignatureSettingsRequiredBy,
  ESignatureSettingsType,
  TFormBuilderContent,
} from '@/types';

export const formBuilderElements: Record<
  EFormBuilderFieldType,
  { value: string; icon: IconsUnion }
> = {
  [EFormBuilderFieldType.TEXT]: {
    value: 'form-builder.text',
    icon: 'Text',
  },
  [EFormBuilderFieldType.CHECKBOX]: {
    value: 'form-builder.checkbox',
    icon: 'CheckSquareBroken',
  },
  [EFormBuilderFieldType.SINGLE_LINE_INPUT]: {
    value: 'form-builder.single-line-input',
    icon: 'TextInputSingle',
  },
  [EFormBuilderFieldType.MULTILINE_INPUT]: {
    value: 'form-builder.multiline-input',
    icon: 'TextInputMulti',
  },
  [EFormBuilderFieldType.SINGLE_CHOICE]: {
    value: 'form-builder.single-choice',
    icon: 'RadioButton',
  },
  [EFormBuilderFieldType.MULTIPLE_CHOICE]: {
    value: 'form-builder.multiple-choice',
    icon: 'CheckSquare',
  },
  [EFormBuilderFieldType.DROPDOWN]: {
    value: 'form-builder.dropdown',
    icon: 'ChevronDown',
  },
  [EFormBuilderFieldType.DATE]: {
    value: 'common.date',
    icon: 'CalendarDay',
  },
  [EFormBuilderFieldType.FILE]: {
    value: 'form-builder.file-upload',
    icon: 'Upload',
  },
  [EFormBuilderFieldType.TEXT_EDITOR]: {
    value: 'form-builder.text-editor',
    icon: 'TextInputMulti',
  },
};

export const formBuilderSignatureConfig: Record<
  TFormBuilderContent,
  {
    allowedTypes: ESignatureSettingsType[];
    withRequiredBy: boolean;
    defaultRequiredBy: ESignatureSettingsRequiredBy;
  }
> = {
  formBuilder: {
    allowedTypes: [
      ESignatureSettingsType.NO_SIGNATURE,
      ESignatureSettingsType.TYPED,
      ESignatureSettingsType.DRAW_AND_TYPED,
    ],
    withRequiredBy: true,
    defaultRequiredBy: ESignatureSettingsRequiredBy.PATIENT,
  },
  // Only a provider can sign a visit note, so the picker is dropped and the
  // value is fixed.
  visitNote: {
    allowedTypes: [
      ESignatureSettingsType.NO_SIGNATURE,
      ESignatureSettingsType.TYPED,
    ],
    withRequiredBy: false,
    defaultRequiredBy: ESignatureSettingsRequiredBy.PROVIDER,
  },
};
